export default __webpack_public_path__ + "static/media/profile_v2.95afe968.jpg";